/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Goal_Focus_TInputs */

const en_funnel_ob_goal_focus_t = /** @type {(inputs: Funnel_Ob_Goal_Focus_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus & remember more`)
};

const es_funnel_ob_goal_focus_t = /** @type {(inputs: Funnel_Ob_Goal_Focus_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concentrarme y retener más`)
};

/**
* | output |
* | --- |
* | "Focus & remember more" |
*
* @param {Funnel_Ob_Goal_Focus_TInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_goal_focus_t = /** @type {((inputs?: Funnel_Ob_Goal_Focus_TInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Goal_Focus_TInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_goal_focus_t(inputs)
	return en_funnel_ob_goal_focus_t(inputs)
});